// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/ProximaNova-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/ProximaNova-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/ProximaNova-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/ProximaNova-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/fonts/ProximaNova-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/fonts/ProximaNova-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'ProximaNova';
    src: local('ProximaNova'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
    font-display: swap;
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'ProximaNova';
    src: local('ProximaNova-SemiBold'),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
    font-display: swap;
    font-weight: 600;
    font-style: normal;
}

@font-face {
    font-family: 'ProximaNova';
    src: local('ProximaNova-Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
    font-display: swap;
    font-weight: 700;
    font-style: normal;
}
html,
body {
    overscroll-behavior: none;
    font-family: 'ProximaNova', sans-serif;
}

body {
    background: var(--neutral50);
    font-size: var(--fs-body);
    color: var(--black);
}

#root {
    height: 100%;
}

/**
 * ⚠️ Forbidden for accessibility reason and should be removed as soon as possible
 * https://www.outlinenone.com/
 */
:focus {
    outline: 0;
}

hr {
    border: 0;
    border-bottom: 1px solid var(--neutral100);
}

a[href='javascript:openAxeptioCookies()'] {
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    margin: 0 -1px -1px 0;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    white-space: nowrap;
}

#newsletter ul li {
    list-style: initial;
}

#newsletter ol li {
    list-style: decimal;
}

/* Legacy - RELATED TO DEPRECATED MODAL */
#modal-background {
    z-index: 6;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    overflow: auto;
}

/* Legacy - RELATED TO DEPRECATED MODAL */
#backgroundPortal {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 1000;
    background: black;
    opacity: 0.5;
}

.transcription-seek-audio-button {
    position: absolute;
    margin-top: -1rem;
    padding: 0;
    height: 2rem;
    border: none;
    background: transparent;
    color: var(--neutral500);
    white-space: nowrap;
    cursor: pointer;
}

.transcription-speaker {
    position: absolute;
    margin-left: -10rem;
    font-weight: var(--fw-bold);
}

.transcription-current-playing-node {
    background: #F1E8F9;
    border-radius: var(--r-s);
    padding: 0.25rem;
    margin: 0 -0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B;8DACqE;IACrE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B;;8DAEsE;IACtE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B;8DACkE;IAClE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;IAEI,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;EAGE;AACF;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,0CAA0C;AAC9C;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yCAAyC;AACzC;IACI,UAAU;IACV,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA,yCAAyC;AACzC;IACI,YAAY;IACZ,aAAa;IACb,MAAM;IACN,OAAO;IACP,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: 'ProximaNova';\n    src: local('ProximaNova'), url('../../public/fonts/ProximaNova-Regular.woff2') format('woff2'),\n        url('../../public/fonts/ProximaNova-Regular.woff') format('woff');\n    font-display: swap;\n    font-weight: 400;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'ProximaNova';\n    src: local('ProximaNova-SemiBold'),\n        url('../../public/fonts/ProximaNova-Semibold.woff2') format('woff2'),\n        url('../../public/fonts/ProximaNova-Semibold.woff') format('woff');\n    font-display: swap;\n    font-weight: 600;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'ProximaNova';\n    src: local('ProximaNova-Bold'), url('../../public/fonts/ProximaNova-Bold.woff2') format('woff2'),\n        url('../../public/fonts/ProximaNova-Bold.woff') format('woff');\n    font-display: swap;\n    font-weight: 700;\n    font-style: normal;\n}\nhtml,\nbody {\n    overscroll-behavior: none;\n    font-family: 'ProximaNova', sans-serif;\n}\n\nbody {\n    background: var(--neutral50);\n    font-size: var(--fs-body);\n    color: var(--black);\n}\n\n#root {\n    height: 100%;\n}\n\n/**\n * ⚠️ Forbidden for accessibility reason and should be removed as soon as possible\n * https://www.outlinenone.com/\n */\n:focus {\n    outline: 0;\n}\n\nhr {\n    border: 0;\n    border-bottom: 1px solid var(--neutral100);\n}\n\na[href='javascript:openAxeptioCookies()'] {\n    border: 0;\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: 0 -1px -1px 0;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n    white-space: nowrap;\n}\n\n#newsletter ul li {\n    list-style: initial;\n}\n\n#newsletter ol li {\n    list-style: decimal;\n}\n\n/* Legacy - RELATED TO DEPRECATED MODAL */\n#modal-background {\n    z-index: 6;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.4);\n    overflow: auto;\n}\n\n/* Legacy - RELATED TO DEPRECATED MODAL */\n#backgroundPortal {\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    position: fixed;\n    z-index: 1000;\n    background: black;\n    opacity: 0.5;\n}\n\n.transcription-seek-audio-button {\n    position: absolute;\n    margin-top: -1rem;\n    padding: 0;\n    height: 2rem;\n    border: none;\n    background: transparent;\n    color: var(--neutral500);\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.transcription-speaker {\n    position: absolute;\n    margin-left: -10rem;\n    font-weight: var(--fw-bold);\n}\n\n.transcription-current-playing-node {\n    background: #F1E8F9;\n    border-radius: var(--r-s);\n    padding: 0.25rem;\n    margin: 0 -0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
